export enum INSIGHTS_ANALYSIS_TAB_ITEMS {
  BASIC_DETAILS = "details",
  TIMELINE = "timeline",
  // SCORES,
  VENDOR = "vendor",
  TASKS = "tasks",
  NOTIFICATIONS = "notifications",
  KPIS = "kpis",
  RISK_ALL = "risks",
  RISK_HIGH = "risks_high",
  RISK_MEDIUM = "risks_medium",
  RISK_LOW = "risks_low",
  SCORES_V2 = "deviations",
  FIELDS_FOUND = "matched",
  FIELDS_NOT_FOUND = "missing",
  FIELDS_NOT_ANALYZED = "not_analyzed",
  FIELDS_EXCLUDED = "excluded",
  FIELDS_SUGGESTED = "suggested",
  CONTRACT_MANAGEMENT = "manage",
  AI_ASSISTANT = "ai_assistant",
}

export interface ITab {
  main?: boolean;
  label: string;
  value: string | INSIGHTS_ANALYSIS_TAB_ITEMS;
  iconOnly?: boolean;
  icon?: React.ReactNode;
  children?: ITab[];
}
